<template>
<div class="page page_hezuo">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
            <div class="list">
                <div class="item" v-for="photo in photoList" :key="photo.id" @click="editPhoto(photo)">
                    <div class="date">{{photo.time}}</div>
                    <div class="name" v-if="photo.cate">{{photo.cate.title}}</div>
                    <div class="image_back">
                        <van-image fit="cover" class="photo" v-for="(img,index) in photo.albumArr" :key="index" :src="imageUrl+img" />
                    </div>
                </div>
                
            </div>
        </van-list>
    </van-pull-refresh>
    <div class="post" @click="addNewPhoto" >
        <img :src="publicPath+'statics/images/icon_fabu.png'" alt="" class="">
    </div>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            photoList: [],
            token: '',
            show: false, // 时间选择弹层
            timepicker: false, // 时间插件pop层
            starttime: '',
            endtime: '',
            currentDate: new Date(),
            minDate: new Date(),
            finished: false,
            page: 1,
            size: 10,
            loading: false,
            refreshing: false,
        };
    },
    created: function () {
        
    },
    mounted: function () {

        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            //修改导航栏样式
            var styleParams = {
                'data': {
                    'naviTitle': '图集管理',
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', styleParams, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.onRefresh()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                this.onRefresh()
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token
            // 获取列表
            this.onRefresh();
        }

    },
    methods: {
        addNewPhoto() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl + '/tradesman/photoadd'
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                this.$router.push({
                    path: '/tradesman/photoadd'
                })
            }
        },
        editPhoto(item) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl + '/tradesman/photoadd?id='+item.id
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                this.$router.push({
                    path: '/tradesman/photoadd?id='+item.id
                })
            }
        },
        onRefresh() {
            // 清空列表数据
            this.finished = false;

            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.page = 1
            this.getData();
        },
        // 获取列表
        getData() {
            // return
            var that = this
            var params = {
                token: this.token,
                page: this.page,
                size: this.size
            }
            this.$api.tradesman.thumbList(params).then(res => {
                if (res.code == 200) {
                    if (res.result && res.result.list.length > 0) {
                        var list = res.result.list
                        console.log('list:',list)
                        for (let i = 0; i < list.length; i++) {
                            const item = list[i];
                            if (item.album && item.album != undefined && item.album != '') {
                                item.albumArr = item.album.split(",")
                            }
                        }
                        that.photoList = list
                        if (list.length <= this.size) {
                            // 数据全部加载完
                            that.finished = true
                            that.refreshing = false
                            return;
                        }
                    } else {
						that.photoList = []
						that.finished = true
                    }

                } else {
                    photoList.finished = true
                    photoList.$toast(res.message)
                }
                that.page++;
                that.refreshing = false
                that.loading = false;
            })
        },
        
        
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
/deep/.van-cell .van-field__control {
    color: #000;
}
/deep/.van-dialog__content .title{
	width: 100%;
	padding: .2rem 0;
	text-align: center;
	font-size: .4rem;
}
/deep/.van-dialog__content .van-cell-group .van-cell{
	padding: .1rem .53rem;
}
</style>
